






































import ICompany from '@/store/models/ICompany';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Vue, Component, Watch } from 'vue-property-decorator';
import CompanyApi from '../store/api/CompanyApi';
import ListPhonePrefixesApi from '../store/api/ListPhonePrefixesApi';
import CompanySelector from '@/components/selectors/Company/CompanySelector.vue';
import ICompanyAdresses from '@/store/models/ICompanyAdresses';
import IListCountries from '@/store/models/IListCountries';
import ListCountriesApi from '@/store/api/ListCountriesApi';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import ListAdressTypesApi from '@/store/api/ListAdressTypesApi';
import CompanyAdressesApi from '@/store/api/CompanyAdressesApi';
import ICompanyContacts from '@/store/models/ICompanyContacts';
import CompanyContactsApi from '@/store/api/CompanyContactsApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IAuthentication from '@/store/models/IAuthentication';

@Component({
    components: {
        CompanySelector,
        Snackbar
    }
})
export default class Companies extends Vue {
    // CompanySelector
    CompanyList : ICompany[] = [];
    companyApi : CompanyApi;
    ListPhonePrefix : IListPhonePrefix[] = [];
    listPhonePrefixesApi : ListPhonePrefixesApi;
    phonePrefixCountry : string[] = [];
    selectedCompany : ICompany | null = null;
    idCompany : string = "";
    // CompanyAdressesSelector
    CompanyAdressesList : ICompanyAdresses[] = [];
    companyAdressesApi : CompanyAdressesApi;
    ListCountries : IListCountries[] = [];
    listCountriesApi : ListCountriesApi;
    ListAdressTypes : IListAdressTypes[] = [];
    listAdressTypesApi : ListAdressTypesApi;
    countryName : string[] = [];
    adressTypeName : string[] = [];
    selectedCompanyAdres : ICompany[] = [];

    // CompanyContactsSelector
    CompanyContactsList : ICompanyContacts[] = [];
    companyContactsApi : CompanyContactsApi;
    permissions : IRolePermission[] = [];
    userName : string = "";
    overlay: boolean = false;

    constructor() {
        super();
        this.companyApi = new CompanyApi();
        this.listPhonePrefixesApi = new ListPhonePrefixesApi();
        this.listCountriesApi = new ListCountriesApi();
        this.listAdressTypesApi = new ListAdressTypesApi();
        this.companyAdressesApi = new CompanyAdressesApi();
        this.companyContactsApi = new CompanyContactsApi();
    }

    created() {
        this.getPermissions();
        this.getCompanies();
        this.getListPhonePrefixes();
        this.getCountries();
        this.getAdresTypes();
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Companies"));
    }

    companyChanged(company: ICompany) {
        if (company !== undefined && Object.keys(company).length !== 0) {
            this.getCompanyAdresses(this.selectedCompany!.id);
            this.getCompanyContacts(this.selectedCompany!.id);
        }
    }

    async getCompanies() {
        this.CompanyList = await this.companyApi.GetCompaniesById(this.idCompany);
    }

    async getListPhonePrefixes() {
        this.ListPhonePrefix = await this.listPhonePrefixesApi.GetListPhonePrefixes();
        if (this.ListPhonePrefix) {
            this.phonePrefixCountry = this.ListPhonePrefix.map(l => l.country);
        }
    }

    deleteCompany (item: ICompany) {
        confirm('Are you sure you want to delete this company?') && this.deleteCompanyItem(item);
    }

    async deleteCompanyItem(company: ICompany) {
        this.overlay = true;
        let result: boolean = await this.companyApi.DeleteCompany(company.id);
        if (result) {
            const index = this.CompanyList.indexOf(company);
            this.CompanyList.splice(index, 1);
            this.showMessageInfo(`The company ${company.name} has been successfully deleted`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCompany (company: ICompany) {
        this.overlay = true;
        if (!company.id) {
            const id = await this.companyApi.SaveCompany(company);
            if (id) {
                company.id = id;
                this.CompanyList = [company].concat(this.CompanyList);
                this.selectedCompany = company;
                this.showMessageInfo(`The company ${company.name} has been successfully saved`);
            } else {
                const errors: string = this.companyApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.overlay = false;
    }

    async editCompany (editedCompany: ICompany) {
        this.overlay = true;
        let result : boolean = await this.companyApi.UpdateCompany(editedCompany);
        if (result) {
            this.showMessageInfo(`The company ${editedCompany.name} has been successfully edited`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
 
    async getCountries() {
        if (this.ListCountries.length === 0) {
            this.ListCountries = await this.listCountriesApi.GetListCountries();
            if (this.ListCountries) {
                this.countryName = this.ListCountries.map(l => l.countryName);
            }
        }
    }

    async getAdresTypes() {
        if (this.ListAdressTypes.length === 0) {
            this.ListAdressTypes = await this.listAdressTypesApi.GetListAdressesTypes();
            if (this.ListAdressTypes) {
                this.adressTypeName = this.ListAdressTypes.map(l => l.typeName);
            }
        }
    }

    async getCompanyAdresses(companyId: string) {
        this.CompanyAdressesList = await this.companyAdressesApi.GetCompanyAdresses(companyId);
    }

    deleteCompanyAdress (item: ICompanyAdresses) {
        confirm('Are you sure you want to delete this company Adres?') && this.deleteCompanyAdressItem(item);
    }

    async deleteCompanyAdressItem(companyAdres: ICompanyAdresses) {
        this.overlay = true;
        let result: boolean = await this.companyAdressesApi.DeleteCompanyAdres(companyAdres.id);
        if (result) {
            const index = this.CompanyAdressesList.indexOf(companyAdres);
            this.CompanyAdressesList.splice(index, 1);
            this.showMessageInfo(`The company adress has been successfully deleted`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCompanyAdress (editedCompanyAdres: ICompanyAdresses) {
        this.overlay = true;
        editedCompanyAdres.idCompany = this.selectedCompany!.id;
        const companyAdresId = await this.companyAdressesApi.SaveCompanyAdres(editedCompanyAdres);
        if (companyAdresId) {
            editedCompanyAdres.id = companyAdresId;
            this.CompanyAdressesList = [editedCompanyAdres].concat(this.CompanyAdressesList);
            this.showMessageInfo(`The company adress has been successfully saved`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = true;
    }

    async editCompanyAdress (editedCompanyAdres: ICompanyAdresses) {
        this.overlay = true;
        let result : boolean = await this.companyAdressesApi.UpdateCompanyAdres(editedCompanyAdres);
        if (result) {
            this.showMessageInfo(`The company adres has been successfully edited`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getCompanyContacts(companyId: string) {
        this.CompanyContactsList = await this.companyContactsApi.GetCompanyContacts(companyId);
    }

    deleteCompanyContact (item: ICompanyContacts) {
        confirm('Are you sure you want to delete this company Contact?') && this.deleteCompanyContactItem(item);
    }

    async deleteCompanyContactItem(companyContact: ICompanyContacts) {
        this.overlay = true;
        let result: boolean = await this.companyContactsApi.DeleteCompanyContact(companyContact.id);
        if (result) {
            const index = this.CompanyContactsList.indexOf(companyContact);
            this.CompanyContactsList.splice(index, 1);
            this.showMessageInfo(`The company contact has been successfully deleted`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveCompanyContact (companyContact: ICompanyContacts) {
        this.overlay = true;
        companyContact.idCompany = this.selectedCompany!.id;
        const companyContactId = await this.companyContactsApi.SaveCompanyContact(companyContact);
        if (companyContactId) {
            companyContact.id = companyContactId;
            this.CompanyContactsList = [companyContact].concat(this.CompanyContactsList);
            this.showMessageInfo(`The company contact has been successfully saved`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editCompanyContact (editedCompanyContact: ICompanyContacts) {
        this.overlay = true;
        let result : boolean = await this.companyContactsApi.UpdateCompanyContact(editedCompanyContact);
        if (result) {
            this.showMessageInfo(`The company contact has been successfully edited`);
        } else {
            const errors: string = this.companyApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetCompany() {
        this.selectedCompany = null;
        this.CompanyContactsList = [];
        this.CompanyAdressesList = [];
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
